import PropTypes from 'prop-types';
import { useMemo } from 'react';

import OffersCarousel from 'components/OffersCarousel';
import OffersCarouselHeadingContentWithCategoryLinks from 'components/OffersCarousel/HeadingContentWithCategoryLinks';

const ThreadOffersCarousel = ({ gaEventCategory, relatedOffers }) => {
  const categoriesFromRelatedOffers = useMemo(
    () =>
      relatedOffers
        .filter((offer) => offer?.categorySlug)
        .map((offer) => ({
          categoryId: offer.categoryId,
          categoryName: offer.categoryName,
          categorySlug: offer.categorySlug,
        })),
    [relatedOffers]
  );

  const subcategoriesFromRelatedOffers = useMemo(
    () =>
      relatedOffers
        .filter((offer) => offer?.subcategorySlug)
        .map((offer) => ({
          subcategoryId: offer.subcategoryId,
          subcategoryName: offer.subcategoryName ?? '',
          subcategorySlug: offer.subcategorySlug,
        })),
    [relatedOffers]
  );

  return (
    <OffersCarousel
      className="mt-6"
      gaEventActionPrefix="carousel"
      gaEventCategory={gaEventCategory}
      headingProps={{
        children: (
          <OffersCarouselHeadingContentWithCategoryLinks
            categories={categoriesFromRelatedOffers}
            subcategories={subcategoriesFromRelatedOffers}
          />
        ),
      }}
      offers={relatedOffers}
    />
  );
};

ThreadOffersCarousel.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  relatedOffers: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  threadId: PropTypes.number.isRequired,
};

export default ThreadOffersCarousel;
